module.exports = __webpack_public_path__ + "img/56_feteTheFungus.1cf3cc0c.jpg";